export class KnowledgeNotFoundError extends Error {}
